import { render } from "./account-bank.vue?vue&type=template&id=4232056b"
import script from "./account-bank.vue?vue&type=script&lang=js"
export * from "./account-bank.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__